import { render, staticRenderFns } from "./TestCodeDialog.vue?vue&type=template&id=5cc90a59&"
import script from "./TestCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./TestCodeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TestCodeDialog.vue?vue&type=style&index=0&id=5cc90a59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports